<template>
  <Card variant="secondary" size="medium" class="wants-to-apply-card" @click="emit('open')">
    <View gap="md" direction="column">
      <Text variant="label-medium" color="secondary">Wants to apply</Text>
      <View gap="sm" direction="column">
        <View gap="sm">
          <PropertyPhotoPreview :image-url="inquiry.property.coverImage ?? undefined" size="sm" />

          <View justify="center" direction="column">
            <Text variant="h5">{{ inquiry.property.displayName }}</Text>
            <Text variant="label-medium" color="secondary">{{ renterName }} asked to apply</Text>
          </View>
        </View>

        <View gap="md" justify="space-between" align="end">
          <Text variant="body-small" color="secondary">Asked {{ askedAgo }}</Text>
          <!-- The card's own click opens the panel; the button is its keyboard and visual handle -->
          <Button variant="primary" size="medium">Review</Button>
        </View>
      </View>
    </View>
  </Card>
</template>

<script setup lang="ts">
import { useTimeAgo } from '@vueuse/core';
import { computed } from 'vue';

import { Button, Card, Text, View } from '@tallo/design-system';
import { PropertyInquiryDto } from '@tallo/investor/property';
import { PropertyPhotoPreview } from '@tallo/property';

/** A renter waiting for the owner to answer their ask to apply; the app opens the wants-to-apply panel on `open`. */
const props = defineProps<{ inquiry: PropertyInquiryDto }>();
const emit = defineEmits<{ open: [] }>();

const renterName = computed(() => props.inquiry.renter.user.name);
const askedAgo = useTimeAgo(() => props.inquiry.applicationRequestedAt ?? props.inquiry.createdAt);
</script>

<style scoped lang="scss">
.wants-to-apply-card {
  cursor: pointer;
}
</style>
